// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2eVPl","list":"styles_list__N7xCT"};